import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filesize',
    standalone: false
})
export class FilesizePipe implements PipeTransform {
  public transform(value) {
    if (typeof(value) !== 'number' ) { return value; }
    value = value / 1024;

    if (value > 1000) { return Math.round(value / 1000) + 'mb'; }
    return Math.round(value) + 'kb';
  }
}
